var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.27671",
      "conversations-internal-schema": "static-1.13262",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8230",
      "hubspot-url-utils": "static-1.4279",
      "HubStyleTokens": "static-2.11680",
      "I18n": "static-7.1650",
      "jasmine-runner": "static-1.6660",
      "quartz": "static-1.7303",
      "react": "static-7.190",
      "reselect": "static-3.8",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.491",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6349",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "bend-plugin-trellis-migration": "static-1.3543",
      "moment": "static-3.26",
      "customer-data-email": "static-1.18394",
      "cv-backend-services": "static-1.1589",
      "hub-http": "static-1.6423",
      "immutable": "static-2.83",
      "immutable-less": "static-1.4856",
      "quartz-config": "static-1.1081",
      "quartz-core": "static-1.6522",
      "transmute": "static-2.85",
      "HeadJS": "static-2.781",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8314",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3341",
      "msw": "static-1.39",
      "react-redux": "static-7.75",
      "redux": "static-4.16",
      "testing-library": "static-1.155",
      "foundations-theming": "static-1.4649",
      "i18n-data": "static-1.225",
      "metrics-js": "static-1.9845",
      "moment-timezone": "static-5.86",
      "react-utils": "static-2.5484",
      "jasmine": "static-4.4529",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3103",
      "react-aria": "static-1.69",
      "styled-components": "static-2.93",
      "UIComponents": "static-3.8626",
      "visitor-ui-component-library-icons": "static-1.6160",
      "bender-build-tools": "static-1.3323",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4860",
      "apollo-stack-hubspot": "static-3.89",
      "classnames": "static-2.10",
      "cssUtils": "static-1.853",
      "customer-data-objects": "static-1.7888",
      "customer-data-ui-utilities": "static-1.10030",
      "data-fetching-client": "static-1.9863",
      "FileManagerCore": "static-1.39724",
      "FileManagerLib": "static-1.39865",
      "foundations-assets": "static-1.5081",
      "graphql": "static-1.85",
      "hs-promise-utils": "static-1.5799",
      "hubspot-apollo-client": "static-1.5083",
      "icons": "static-2.668",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.108",
      "react-virtualized": "static-2.102",
      "rpc-client-utils": "static-1.4864",
      "salesImages": "static-1.529",
      "timezone-utils": "static-2.5450",
      "ui-gdpr-components": "static-1.10556",
      "ts-schema": "static-1.4223",
      "hs-locale-management": "static-1.224",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.858",
      "hubspotter-http": "static-1.4794",
      "mobile-manifest-mixins": "static-1.555",
      "module-federation": "static-1.29",
      "quartz-auth": "static-1.978",
      "quartz-head": "static-1.968",
      "quartz-i18n": "static-1.978",
      "quartz-routing": "static-1.733",
      "quartz-test": "static-1.978",
      "quartz-tracking": "static-1.682",
      "quick-fetch": "static-1.4060",
      "react-rhumb": "static-1.16910",
      "trellis-components": "static-1.2367",
      "ui-fonts": "static-1.942",
      "usage-tracker-container": "static-1.7547",
      "usage-tracker-core": "static-1.7407",
      "bend-plugin-foundations-components": "static-1.4583",
      "floating-ui": "static-1.60",
      "foundations-theming-specialty": "static-1.2365",
      "hs-story-utils": "static-1.9631",
      "react-create-root-preference": "static-1.50",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2348",
      "ui-images": "static-2.1214",
      "bend-plugin-foundations-theming": "static-1.3132",
      "foundations-theming-base": "static-1.3634",
      "stylex": "static-1.37",
      "HubStyle": "static-2.11987",
      "sassPrefix": "static-1.160",
      "inbound-db-properties-service-client": "static-1.3988",
      "property-translator": "static-1.5601",
      "react-dnd-compat": "static-1.4820",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9468",
      "audio-components": "static-1.6215",
      "ContentUtils": "static-1.68952",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29668",
      "file-manager-components": "static-1.24225",
      "FileManagerImages": "static-1.37376",
      "foundations-components-legacy": "static-1.1339",
      "html-to-image": "static-1.57",
      "immerable": "static-1.4354",
      "react-colorpicker": "static-2.10415",
      "redux-toolkit": "static-1.7",
      "ui-universal-auth": "static-1.9225",
      "urlinator": "static-1.4738",
      "video-components": "static-1.13930",
      "video-data-lib": "static-1.35586",
      "video-embed": "static-1.36420",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.542",
      "bend-plugin-chirp-manifest": "static-1.274",
      "chirp-fetch": "static-1.2093",
      "hub-http-shared-msw-handlers": "static-1.10451",
      "hubspotter-http-shared-msw-handlers": "static-1.10449",
      "usage-tracker-session-replay": "static-1.5243",
      "web-vitals": "static-1.9",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "trellis-theming": "static-1.1159",
      "tanstack-virtual": "static-1.33",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.22351",
      "copilot-toolkit": "static-1.11654",
      "customer-data-objects-ui-components": "static-1.13237",
      "sanitize": "static-1.4683",
      "sanitize-text": "static-1.8352",
      "content-assistance-lib": "static-1.8064",
      "usage-tracker": "static-1.7557",
      "cms-field-types": "static-1.5021",
      "content-icons-ui": "static-1.2289",
      "integrations-lib": "static-1.16793",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.1437",
      "ui-addon-iframeable": "static-1.9280",
      "video-components-external": "static-1.11928",
      "unified-auth-core-lib": "static-1.1021",
      "social-insights-client-types": "static-1.22598",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4371",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5697",
      "magpie-types": "static-1.5157",
      "simple-logging-lib": "static-1.3255",
      "atom": "static-1.5282",
      "avatar-components": "static-1.2703",
      "reference-resolvers": "static-1.8383",
      "superstore": "static-1.4964",
      "ui-addon-video-player": "static-1.8912",
      "ui-coaching-tips": "static-1.29120",
      "flux-actions": "static-1.355",
      "frontend-preferences-client": "static-1.8132",
      "integrations-error-boundary-lib": "static-1.14208",
      "integrations-tracking-lib": "static-1.5813",
      "laboratory-lib": "static-3.7357",
      "native-integrations-shared-strings": "static-1.7983",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10571",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11353",
      "ui-shepherd-react": "static-3.10467",
      "unified-auth": "static-1.739",
      "breeze-engine-chat-components": "static-1.415",
      "breeze-engine-core": "static-1.715",
      "ably": "static-2.2",
      "highlight.js": "static-1.82",
      "navigation-messaging": "static-1.7931",
      "content-media-composition-data-lib": "static-1.12975",
      "content-media-compositions": "static-2.16982",
      "idb-keyval": "static-1.47",
      "media-bridge-lib": "static-1.19274",
      "fsm": "static-1.3938",
      "reactive-lib": "static-1.928",
      "growth-onboarding-feedback-components": "static-1.6787",
      "universal-page-editor-lib": "static-1.3217",
      "foundations-components-test-utils": "static-1.5797",
      "adobe-sign-auth-lib": "static-1.255",
      "ads-unified-auth-lib": "static-1.780",
      "google-sheets-integration-lib": "static-1.832",
      "microsoft-drive-integration-lib": "static-1.942",
      "surveymonkey-integration-lib": "static-1.277",
      "slack-ui-library": "static-1.10605",
      "js-cookie": "static-1.18",
      "react-dlb": "static-1.83",
      "crm-record-cards-service-types": "static-1.3727",
      "framework-data-schema-resolvers": "static-1.7100",
      "location-customization-utils-lib": "static-1.9877",
      "batch-promise": "static-1.1750",
      "conditional-properties-service-client": "static-1.3940",
      "crm-pipelines-api-client-types": "static-1.4280",
      "fdsr-migration-layer": "static-1.219",
      "framework-builder-read-service-client": "static-1.4149",
      "framework-data-schema-quick-fetch": "static-1.7005",
      "inbound-db-meta-service-client": "static-1.3718",
      "multi-currency-client-types": "static-1.3834",
      "persist-promise": "static-1.3907"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.27671",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13262",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8230",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4279",
      "HubStyleTokens": "/HubStyleTokens/static-2.11680",
      "I18n": "/I18n/static-7.1650",
      "jasmine-runner": "/jasmine-runner/static-1.6660",
      "quartz": "/quartz/static-1.7303",
      "react": "/react/static-7.190",
      "reselect": "/reselect/static-3.8",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.491",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6349",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3543",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.18394",
      "cv-backend-services": "/cv-backend-services/static-1.1589",
      "hub-http": "/hub-http/static-1.6423",
      "immutable": "/immutable/static-2.83",
      "immutable-less": "/immutable-less/static-1.4856",
      "quartz-config": "/quartz-config/static-1.1081",
      "quartz-core": "/quartz-core/static-1.6522",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.781",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8314",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3341",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.75",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.155",
      "foundations-theming": "/foundations-theming/static-1.4649",
      "i18n-data": "/i18n-data/static-1.225",
      "metrics-js": "/metrics-js/static-1.9845",
      "moment-timezone": "/moment-timezone/static-5.86",
      "react-utils": "/react-utils/static-2.5484",
      "jasmine": "/jasmine/static-4.4529",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3103",
      "react-aria": "/react-aria/static-1.69",
      "styled-components": "/styled-components/static-2.93",
      "UIComponents": "/UIComponents/static-3.8626",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6160",
      "bender-build-tools": "/bender-build-tools/static-1.3323",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4860",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.853",
      "customer-data-objects": "/customer-data-objects/static-1.7888",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10030",
      "data-fetching-client": "/data-fetching-client/static-1.9863",
      "FileManagerCore": "/FileManagerCore/static-1.39724",
      "FileManagerLib": "/FileManagerLib/static-1.39865",
      "foundations-assets": "/foundations-assets/static-1.5081",
      "graphql": "/graphql/static-1.85",
      "hs-promise-utils": "/hs-promise-utils/static-1.5799",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5083",
      "icons": "/icons/static-2.668",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-virtualized": "/react-virtualized/static-2.102",
      "rpc-client-utils": "/rpc-client-utils/static-1.4864",
      "salesImages": "/salesImages/static-1.529",
      "timezone-utils": "/timezone-utils/static-2.5450",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10556",
      "ts-schema": "/ts-schema/static-1.4223",
      "hs-locale-management": "/hs-locale-management/static-1.224",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.858",
      "hubspotter-http": "/hubspotter-http/static-1.4794",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
      "module-federation": "/module-federation/static-1.29",
      "quartz-auth": "/quartz-auth/static-1.978",
      "quartz-head": "/quartz-head/static-1.968",
      "quartz-i18n": "/quartz-i18n/static-1.978",
      "quartz-routing": "/quartz-routing/static-1.733",
      "quartz-test": "/quartz-test/static-1.978",
      "quartz-tracking": "/quartz-tracking/static-1.682",
      "quick-fetch": "/quick-fetch/static-1.4060",
      "react-rhumb": "/react-rhumb/static-1.16910",
      "trellis-components": "/trellis-components/static-1.2367",
      "ui-fonts": "/ui-fonts/static-1.942",
      "usage-tracker-container": "/usage-tracker-container/static-1.7547",
      "usage-tracker-core": "/usage-tracker-core/static-1.7407",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4583",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2365",
      "hs-story-utils": "/hs-story-utils/static-1.9631",
      "react-create-root-preference": "/react-create-root-preference/static-1.50",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2348",
      "ui-images": "/ui-images/static-2.1214",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3132",
      "foundations-theming-base": "/foundations-theming-base/static-1.3634",
      "stylex": "/stylex/static-1.37",
      "HubStyle": "/HubStyle/static-2.11987",
      "sassPrefix": "/sassPrefix/static-1.160",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3988",
      "property-translator": "/property-translator/static-1.5601",
      "react-dnd-compat": "/react-dnd-compat/static-1.4820",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9468",
      "audio-components": "/audio-components/static-1.6215",
      "ContentUtils": "/ContentUtils/static-1.68952",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29668",
      "file-manager-components": "/file-manager-components/static-1.24225",
      "FileManagerImages": "/FileManagerImages/static-1.37376",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1339",
      "html-to-image": "/html-to-image/static-1.57",
      "immerable": "/immerable/static-1.4354",
      "react-colorpicker": "/react-colorpicker/static-2.10415",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "ui-universal-auth": "/ui-universal-auth/static-1.9225",
      "urlinator": "/urlinator/static-1.4738",
      "video-components": "/video-components/static-1.13930",
      "video-data-lib": "/video-data-lib/static-1.35586",
      "video-embed": "/video-embed/static-1.36420",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.542",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.274",
      "chirp-fetch": "/chirp-fetch/static-1.2093",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10451",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10449",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5243",
      "web-vitals": "/web-vitals/static-1.9",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "trellis-theming": "/trellis-theming/static-1.1159",
      "tanstack-virtual": "/tanstack-virtual/static-1.33",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.22351",
      "copilot-toolkit": "/copilot-toolkit/static-1.11654",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13237",
      "sanitize": "/sanitize/static-1.4683",
      "sanitize-text": "/sanitize-text/static-1.8352",
      "content-assistance-lib": "/content-assistance-lib/static-1.8064",
      "usage-tracker": "/usage-tracker/static-1.7557",
      "cms-field-types": "/cms-field-types/static-1.5021",
      "content-icons-ui": "/content-icons-ui/static-1.2289",
      "integrations-lib": "/integrations-lib/static-1.16793",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1437",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9280",
      "video-components-external": "/video-components-external/static-1.11928",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1021",
      "social-insights-client-types": "/social-insights-client-types/static-1.22598",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4371",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5697",
      "magpie-types": "/magpie-types/static-1.5157",
      "simple-logging-lib": "/simple-logging-lib/static-1.3255",
      "atom": "/atom/static-1.5282",
      "avatar-components": "/avatar-components/static-1.2703",
      "reference-resolvers": "/reference-resolvers/static-1.8383",
      "superstore": "/superstore/static-1.4964",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8912",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29120",
      "flux-actions": "/flux-actions/static-1.355",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8132",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14208",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5813",
      "laboratory-lib": "/laboratory-lib/static-3.7357",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7983",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10571",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11353",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10467",
      "unified-auth": "/unified-auth/static-1.739",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.415",
      "breeze-engine-core": "/breeze-engine-core/static-1.715",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.82",
      "navigation-messaging": "/navigation-messaging/static-1.7931",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12975",
      "content-media-compositions": "/content-media-compositions/static-2.16982",
      "idb-keyval": "/idb-keyval/static-1.47",
      "media-bridge-lib": "/media-bridge-lib/static-1.19274",
      "fsm": "/fsm/static-1.3938",
      "reactive-lib": "/reactive-lib/static-1.928",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6787",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3217",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5797",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.255",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.780",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.832",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.942",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.277",
      "slack-ui-library": "/slack-ui-library/static-1.10605",
      "js-cookie": "/js-cookie/static-1.18",
      "react-dlb": "/react-dlb/static-1.83",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3727",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7100",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9877",
      "batch-promise": "/batch-promise/static-1.1750",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3940",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4280",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.219",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4149",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7005",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3834",
      "persist-promise": "/persist-promise/static-1.3907"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.27671",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};